import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import ClientInsurerIndexGrid from '../components/client-insurer-index/client-insurer-index-grid';
import { DynamicDrawerProvider } from '../context/dynamic-drawer.context';

export const CLIENT_INSURER_INDEX_TEST_ID = 'client-insurer-index-container';

const ClientInsurerIndexPage = (): JSX.Element => (
  <DynamicDrawerProvider>
    <HHStack padding={6} direction="row" alignItems="center" spacing={4}>
      <HHTypography hhVariant="section-title">Client Insurer</HHTypography>
    </HHStack>
    <ClientInsurerIndexGrid />
  </DynamicDrawerProvider>
);

export default ClientInsurerIndexPage;
